export default {
  title: 'BOKISadm',
};
